import {Component, Input, Inject} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export namespace ChangeEmailForm {
  export const FIELD_EMAIL = "email"
}

@Component({
  selector: 'app-change-email-form',
  templateUrl: './change-email-form.component.html'
})
export class ChangeEmailFormComponent {
  @Input() submitting = false

  ChangeEmailForm = ChangeEmailForm

  form = new FormGroup({
    [ChangeEmailForm.FIELD_EMAIL]: new FormControl(null, [Validators.required, Validators.email]),
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { initialEmail?: string },
    private readonly dialogRef: MatDialogRef<ChangeEmailFormComponent>
  ){}

  ngOnInit() {
    const initialEmail = this.data?.initialEmail
    if (initialEmail) this.form.patchValue({email: initialEmail})
  }

  onSubmit() {
    if (this.form.invalid) return
    const email = this.form.value[ChangeEmailForm.FIELD_EMAIL] as string
    this.dialogRef.close({ email })
  }

  onCancel() {
    this.dialogRef.close()
  }
}
